module.exports = __webpack_public_path__ + "static/img/icon_94_chentie.f9144f80.png";